export default import.meta.ROLLUP_FILE_URL_tNPm1O6Dvrd8tHEUNvLnwg